import {Component, OnInit} from '@angular/core';

@Component({
    selector: 'app-better-deals-alert',
    templateUrl: './better-deals-alert.component.html',
    styleUrls: ['./better-deals-alert.component.scss'],
    standalone: false
})
export class BetterDealsAlertComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
